"use client";

import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { User } from 'lucide-react';

interface ProfileAvatarProps {
    src?: string;
    alt?: string;
    className?: string;
}

export function AvatarPlaceholder({ alt, className }: { alt?: string; className?: string }) {
    const initial = alt && alt !== "Professional" ? alt.trim().charAt(0).toUpperCase() : "";

    return (
        <div className={`w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100/70 text-blue-600 font-semibold select-none ${className || ''}`}>
            {initial ? (
                <span className="text-4xl font-bold tracking-wider text-blue-600/90">
                    {initial}
                </span>
            ) : (
                <User className="w-16 h-16 text-blue-500/80 stroke-[1.5]" />
            )}
        </div>
    );
}

export function ProfileAvatar({ src, alt, className }: ProfileAvatarProps) {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setHasError(false);
    }, [src]);

    const isValidSrc = Boolean(src && src.trim() !== "" && src !== "/professional.png");

    return (
        <div className={`relative w-36 h-36 sm:w-44 sm:h-44 rounded-full overflow-hidden shrink-0 border-2 border-blue-100 shadow-sm bg-blue-50 flex items-center justify-center ${className || ''}`}>
            {isValidSrc && !hasError ? (
                <Image
                    src={src!}
                    alt={alt || "Professional Avatar"}
                    fill
                    className="object-cover object-top"
                    priority
                    unoptimized={src?.startsWith('/uploads')}
                    onError={() => setHasError(true)}
                />
            ) : (
                <AvatarPlaceholder alt={alt} />
            )}
        </div>
    );
}

export default ProfileAvatar;
